import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { Button, Card, CardBody, Form, FormFeedback, Input, Label } from "reactstrap"
import { getBazaarStallDetails, updateBazaarStallDetails } from "../../../redux/actions/pvs"
import { useFormik } from "formik"
import * as Yup from "yup"
import { UPDATE_BAZAAR_STALL_DETAILS_RESET } from "../../../redux/types/pvs"
import { toast } from "react-toastify"
import PageLoader from "components/Common/PageLoader"

const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

const EditSlots = () => {
  document.title = "Edit Slot | PULA"

  const query = useQuery()
  const stallId = query.get("id")

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const stallDetails = useSelector(state => state.pvs.stallDetails)
  const updateBazaarStallDetailsScreen = useSelector(
    state => state.screens.pvs.updateBazaarStallDetails
  )

  useEffect(() => {
    dispatch(
      getBazaarStallDetails({
        enc_stall_id: stallId,
      })
    )
  }, [])

  useEffect(() => {
    if (updateBazaarStallDetailsScreen.success) {
      toast.success(updateBazaarStallDetailsScreen.message)
      dispatch({ type: UPDATE_BAZAAR_STALL_DETAILS_RESET })
      // navigate(`/slots-list?id=${row.id}`, {})
      navigate(-1)
    }
    if (updateBazaarStallDetailsScreen.error) {
      toast.error(updateBazaarStallDetailsScreen.error)
      dispatch({ type: UPDATE_BAZAAR_STALL_DETAILS_RESET })
    }
  }, [updateBazaarStallDetailsScreen])

  const formik = useFormik({
    initialValues: {
      stall_type: "",
      stall_size: "",
      description: "",
      stall_number: "",
      base_price: "",
      two_sided_price: "",
      stall_cost: "",
      sequence: "",
      gst: "",
    },
    validationSchema: Yup.object({
      stall_type: Yup.string().required("Stall Type is required"),
      stall_size: Yup.string().required("Stall Size is required"),
      stall_number: Yup.string().required("Stall Number is required"),
      base_price: Yup.string().required("Base Price is required"),
      two_sided_price: Yup.string().required("Two Sided Price is required"),
      stall_cost: Yup.string().required("Stall Cost is required"),
      // sequence: Yup.string().required("Sequence is required"),
    }),
    onSubmit: values => {
      let requestBody = {
        enc_stall_id: stallId,
        stall_type: values.stall_type,
        stall_number: values.stall_number,
        stall_size: values.stall_size,
        base_price: values.base_price,
        two_sides_price: values.two_sided_price,
        stall_cost: values.stall_cost,
        gst: values.gst,
        description: values.description,
      }
      dispatch(updateBazaarStallDetails(requestBody))
    },
  })

  useEffect(() => {
    if (stallDetails) {
      formik.setValues({
        stall_type: stallDetails.stall_type,
        stall_size: stallDetails.stall_size,
        description: stallDetails.description,
        stall_number: stallDetails.stall_number,
        base_price: stallDetails.base_price,
        two_sided_price: stallDetails.two_sides_price,
        stall_cost: stallDetails.stall_cost,
        gst: stallDetails.gst,
        sequence: stallDetails.sequence,
      })
    }
  }, [stallDetails])

  useEffect(() => {
  }, [formik])

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Form onSubmit={formik.handleSubmit}>
          <div className="mb-3"></div>
          <Card>
            <CardBody>
              <h4 className="font-size-18 mb-4">Edit Stall</h4>
              <div className="border-top mt-3 pb-1 mb-2"></div>
              <div className="row align-items-center mt-3 mb-3">
                <div className="col-md-6 col-12">
                  <div className="row">
                    <div className="col-12 col-sm-3">
                      <Label className="form-label" htmlFor="primary_contact">
                        Bazaar Name
                      </Label>
                    </div>
                    <div className="col-12 col-sm-9">
                      <div className="mb-3">
                        <h4 className="font-size-16 mb-4">
                          
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-12 col-sm-4">
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="stall_type">
                      Stall Type
                    </Label>
                    <Input
                      name="stall_type"
                      className="form-control"
                      placeholder="Stall Type"
                      value={formik.values.stall_type}
                      onChange={formik.handleChange}
                      type="text"
                      id="stall_type"
                    />
                    {formik.touched.stall_type && formik.errors.stall_type ? (
                      <FormFeedback type="invalid">
                        {formik.errors.stall_type}
                      </FormFeedback>
                    ) : null}
                  </div>
                </div>
                <div className="col-12 col-sm-4">
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="stall_no">
                      Stall No
                    </Label>
                    <Input
                      name="stall_number"
                      className="form-control"
                      placeholder="Stall No"
                      value={formik.values.stall_number}
                      onChange={formik.handleChange}
                      type="text"
                      id="stall_number"
                    />
                    {formik.touched.stall_number &&
                    formik.errors.stall_number ? (
                      <FormFeedback type="invalid">
                        {formik.errors.stall_number}
                      </FormFeedback>
                    ) : null}
                  </div>
                </div>
                <div className="col-12 col-sm-4">
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="stall_no">
                      Sequence
                    </Label>
                    <Input
                      name="sequence"
                      className="form-control"
                      placeholder="Sequence"
                      value={formik.values.sequence}
                      onChange={formik.handleChange}
                      type="text"
                      id="sequence"
                    />
                    {formik.touched.sequence && formik.errors.sequence ? (
                      <FormFeedback type="invalid">
                        {formik.errors.sequence}
                      </FormFeedback>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-sm-4">
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="stall_size">
                      Stall Size
                    </Label>
                    <Input
                      name="stall_size"
                      className="form-control"
                      placeholder="Stall size"
                      value={formik.values.stall_size}
                      onChange={formik.handleChange}
                      type="text"
                      id="stall_size"
                    />
                    {formik.touched.stall_size && formik.errors.stall_size ? (
                      <FormFeedback type="invalid">
                        {formik.errors.stall_size}
                      </FormFeedback>
                    ) : null}
                  </div>
                </div>
                <div className="col-12 col-sm-4">
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="stall_cost">
                      Base Price
                    </Label>
                    <Input
                      name="base_price"
                      className="form-control"
                      placeholder="Base Price"
                      value={formik.values.base_price}
                      onChange={e => {
                        formik.setFieldValue(
                          "base_price",
                          Number(e.target.value)
                        )
                        formik.setFieldValue(
                          "stall_cost",
                          Number(e.target.value) +
                            Number(formik.values.two_sided_price)
                        )
                      }}
                      type="number"
                      id="base_price"
                    />
                    {formik.touched.base_price && formik.errors.base_price ? (
                      <FormFeedback type="invalid">
                        {formik.errors.base_price}
                      </FormFeedback>
                    ) : null}
                  </div>
                </div>
                <div className="col-12 col-sm-4">
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="stall_cost">
                      2 Sided Price
                    </Label>
                    <Input
                      name="two_sided_price"
                      className="form-control"
                      placeholder="2 Sided Price"
                      value={formik.values.two_sided_price}
                      onChange={e => {
                        formik.setFieldValue(
                          "two_sided_price",
                          Number(e.target.value)
                        )
                        formik.setFieldValue(
                          "stall_cost",
                          Number(formik.values.base_price) +
                            Number(e.target.value)
                        )
                      }}
                      type="number"
                      id="two_sided_price"
                    />
                    {formik.touched.two_sided_price &&
                    formik.errors.two_sided_price ? (
                      <FormFeedback type="invalid">
                        {formik.errors.two_sided_price}
                      </FormFeedback>
                    ) : null}
                  </div>
                </div>
                <div className="col-12 col-sm-4">
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="stall_cost">
                      Stall Cost
                    </Label>
                    <Input
                      name="stall_cost"
                      className="form-control"
                      placeholder="Stall Cost"
                      value={formik.values.stall_cost}
                      onChange={e => {
                        formik.setFieldValue("stall_cost", Number(e.target.value))
                      }}
                      type="number"
                      id="stall_cost"
                    />
                    {formik.touched.stall_cost && formik.errors.stall_cost ? (
                      <FormFeedback type="invalid">
                        {formik.errors.stall_cost}
                      </FormFeedback>
                    ) : null}
                  </div>
                </div>
                <div className="col-12 col-sm-4">
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="stall_cost">
                      GST
                    </Label>
                    <Input
                      name="gst"
                      className="form-control"
                      placeholder="GST"
                      value={formik.values.gst}
                      onChange={formik.handleChange}
                      type="number"
                      id="gst"
                    />
                    {formik.touched.gst && formik.errors.gst ? (
                      <FormFeedback type="invalid">
                        {formik.errors.gst}
                      </FormFeedback>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-12 col-sm-8">
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="description">
                      Description
                    </Label>
                    <textarea
                      name="description"
                      className="form-control"
                      placeholder="Description..."
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      rows={5}
                    ></textarea>
                    {formik.touched.description && formik.errors.description ? (
                      <FormFeedback type="invalid">
                        {formik.errors.description}
                      </FormFeedback>
                    ) : null}
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
          <div className="d-flex justify-content-center">
            <Button
              type="submit"
              color="primary"
              size="md"
              className="btn btn-block font-size-16 mt-3"
            >
              Submit
            </Button>
          </div>
        </Form>
      </div>
      <PageLoader open={updateBazaarStallDetailsScreen.loading} />
    </div>
  )
}

export default EditSlots
